import React, { useState, useEffect } from 'react';

/**
 * Modal pour configurer les paramètres d'optimisation
 */
export default function OptimizationSettingsModal({
  isOpen,
  onClose,
  settings,
  onSave,
}) {
  const [localSettings, setLocalSettings] = useState(settings);

  // Synchroniser avec les props quand le modal s'ouvre
  useEffect(() => {
    if (isOpen) {
      setLocalSettings(settings);
    }
  }, [isOpen, settings]);

  const handleSave = () => {
    onSave(localSettings);
    onClose();
  };

  const handleReset = () => {
    setLocalSettings({
      useTimeWeighting: true,
    });
  };

  if (!isOpen) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000,
      }}
      onClick={onClose}
    >
      <div
        style={{
          backgroundColor: '#fff',
          borderRadius: '12px',
          padding: '24px',
          minWidth: '360px',
          maxWidth: '450px',
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <h2
          style={{
            margin: '0 0 20px 0',
            fontSize: '18px',
            fontWeight: '600',
            color: '#333',
          }}
        >
          Paramètres d'optimisation
        </h2>

        {/* Option: Pondération temporelle */}
        <div style={{ marginBottom: '20px' }}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              padding: '12px',
              backgroundColor: '#f8f9fa',
              borderRadius: '8px',
              cursor: 'pointer',
            }}
            onClick={() =>
              setLocalSettings({
                ...localSettings,
                useTimeWeighting: !localSettings.useTimeWeighting,
              })
            }
          >
            <div>
              <div
                style={{
                  fontSize: '14px',
                  fontWeight: '500',
                  color: '#333',
                  marginBottom: '4px',
                }}
              >
                Pondération temporelle
              </div>
              <div
                style={{
                  fontSize: '12px',
                  color: '#666',
                  lineHeight: '1.4',
                }}
              >
                Privilégie la minimisation des déplacements lorsque le temps entre deux périodes est court
              </div>
            </div>
            <div
              style={{
                width: '44px',
                height: '24px',
                borderRadius: '12px',
                backgroundColor: localSettings.useTimeWeighting ? '#34c759' : '#ccc',
                position: 'relative',
                transition: 'background-color 0.2s',
                flexShrink: 0,
                marginLeft: '12px',
              }}
            >
              <div
                style={{
                  width: '20px',
                  height: '20px',
                  borderRadius: '10px',
                  backgroundColor: '#fff',
                  position: 'absolute',
                  top: '2px',
                  left: localSettings.useTimeWeighting ? '22px' : '2px',
                  transition: 'left 0.2s',
                  boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
                }}
              />
            </div>
          </div>
        </div>

        {/* Boutons d'action */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            marginTop: '24px',
          }}
        >
          <button
            onClick={handleReset}
            style={{
              padding: '10px 16px',
              fontSize: '14px',
              backgroundColor: '#f0f0f0',
              color: '#333',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer',
              transition: 'background-color 0.2s',
            }}
            onMouseEnter={(e) => (e.target.style.backgroundColor = '#e0e0e0')}
            onMouseLeave={(e) => (e.target.style.backgroundColor = '#f0f0f0')}
          >
            Réinitialiser
          </button>
          <div style={{ display: 'flex', gap: '8px' }}>
            <button
              onClick={onClose}
              style={{
                padding: '10px 16px',
                fontSize: '14px',
                backgroundColor: '#f0f0f0',
                color: '#333',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer',
                transition: 'background-color 0.2s',
              }}
              onMouseEnter={(e) => (e.target.style.backgroundColor = '#e0e0e0')}
              onMouseLeave={(e) => (e.target.style.backgroundColor = '#f0f0f0')}
            >
              Annuler
            </button>
            <button
              onClick={handleSave}
              style={{
                padding: '10px 20px',
                fontSize: '14px',
                backgroundColor: '#007bff',
                color: '#fff',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer',
                transition: 'background-color 0.2s',
              }}
              onMouseEnter={(e) => (e.target.style.backgroundColor = '#0056b3')}
              onMouseLeave={(e) => (e.target.style.backgroundColor = '#007bff')}
            >
              Enregistrer
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
